import { render } from "./LunchIcon.vue?vue&type=template&id=55851a2c"
import script from "./LunchIcon.vue?vue&type=script&lang=js"
export * from "./LunchIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__